import { createStore } from "vuex";

const store = createStore({
    strict: true,
    state() {
        return {
            timezoneBehavior: 2,
            adminEmail: '',
            databaseCount: 0,
        };
    },
    getters: {
        getTimezoneBehavior: (state) => {
            return state.timezoneBehavior;
        },
        getAdminEmail: (state) => {
            return state.adminEmail;
        },
        getDatabaseCount: (state) => {
            return state.databaseCount;
        },
    },
    mutations: {
        setTimezoneBehavior: (state, payload) => {
            state.timezoneBehavior = payload;
        },
        setAdminEmail: (state, payload) => {
            state.adminEmail = payload;
        },
        setDatabaseCount: (state, payload) => {
            state.databaseCount = payload;
        },
    },
})

export default store;